/**
 * The pseudo-columns SmartSign's invite copy can mention.
 *
 * The "/" dropdown lists board columns, and these are not columns — they are
 * values the send flow supplies itself (`buildEmailTokenValues`, backend). They
 * ride in the same list because the author does not care about the difference:
 * both are "a thing that fills itself in".
 *
 * `type: 'name'` is not a lie of convenience. It is the pseudo-type the item
 * name already uses to get into this menu (see the `prefillColumns` response in
 * sign-template.controller), and `MENTION_COLUMN_TYPES` admits it. Adding a
 * SmartSign-only type would mean editing a component NPS and Action share.
 *
 * KEEP IN STEP with `LOCAL_TOKEN_IDS` in the backend's send-helpers.ts. A token
 * offered here but missing there is asked of monday as a column that does not
 * exist, and the whole column query comes back short.
 */
export const SIGN_EMAIL_TOKENS = [
  {
    id: 'sender.name',
    title: 'Sender name',
    type: 'name',
    hint: 'Who the request comes from — the board’s verified address, or “SmartSign”.',
  },
  {
    id: 'document.name',
    title: 'Document name',
    type: 'name',
    hint: 'The request’s name, which starts out as its first PDF’s.',
  },
  {
    id: 'name',
    title: 'Item name',
    type: 'name',
    hint: 'The monday item this request was built on.',
  },
];

/**
 * The mention list for the Settings tab's subject and message fields.
 *
 * Tokens first, then the board's own columns: the three above are what the
 * default copy is written in and what most people want, and burying them under
 * an alphabetical run of board columns would hide them.
 *
 * `prefillColumns` already carries an `Item name` entry of its own — it is the
 * same pseudo-column, offered for stamping onto a PDF — so it is dropped here
 * rather than listed twice under two descriptions.
 */
export function emailMentionColumns(prefillColumns = []) {
  return [...SIGN_EMAIL_TOKENS, ...prefillColumns.filter((c) => c.id !== 'name')];
}
